import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import MemberInfo from './memberInfo.vue';
import MemberControl from './memberControl.vue';
import { UserInfo } from '../../../../stores/room';

interface Props {
  userInfo: UserInfo,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    userInfo: null
  },
  setup(__props: any) {



const showMemberControl = ref(false);

function handleMouseEnter() {
  showMemberControl.value = true;
}

function handleMouseLeave() {
  showMemberControl.value = false;
}


return { __sfc: true,showMemberControl, handleMouseEnter, handleMouseLeave, MemberInfo, MemberControl }
}

})